import { render, staticRenderFns } from "./devices-data.vue?vue&type=template&id=e84b5bfa"
import script from "./devices-data.vue?vue&type=script&lang=js"
export * from "./devices-data.vue?vue&type=script&lang=js"
import style0 from "./devices-data.vue?vue&type=style&index=0&id=e84b5bfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports